<div class="login-container">
  <alert></alert>

  <div class="content-container">

    <section class="card-login">

      <div class="card-header">
        <div class="d-flex align-items-center justify-content-between">
          <img class="avux-logo" src="/assets/img/logo/avux-lg-green.svg" alt="Avux logo">
            <language-select></language-select>
        </div>
        <div class="d-flex align-items-center justify-content-between mt-3">
            <span class="logon-text">{{'organization.choose_organization' | translate}}</span>
        </div>

      </div>

      <div class="card-body">

        <loading-spinner *ngIf="loading"></loading-spinner>

        <div class="row" [formGroup]="form">
          <div class="col-md-12 mb-2">
              <kupari-input [class]="'form-control no-right-rounding'" [icon]="'fa-light fa-building-flag'" formControlName="search" [label]="'search.search_criteria'" [clearable]="true"></kupari-input>
          </div>
        </div>
        <div class="tenant-list-wrapper">
          <div class="list-group tenant-list" *ngIf="!loading">
            <ng-container *ngFor="let tenant of filteredTenants; let first = first; let last = last">

              <kupari-button [class]="'list-group-item list-group-item-action'" (onClick)="chooseTenant(tenant.id)" [text]="tenant.name">
              </kupari-button>

            </ng-container>
          </div>
        </div>

        <!-- <div class="text-center">
        <button type="button" class="btn btn-primary btn-sm btn-block mt-3" (click)="cancel()">Return</button>
      </div> -->

      </div>
      <div class="card-footer">
        <app-login-footer></app-login-footer>
      </div>
    </section>

  </div>
  <div class="brand-image-container">
  </div>



</div>
